import styled from '@emotion/styled';

import { typographyVariantStyles } from '@/design-system/typography-variants';

export const LegendContent = styled('div')(({ theme }) => ({
  ...typographyVariantStyles.body3,
  color: theme.colors.text.primary,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',

  ul: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    margin: 0,
    paddingLeft: '20px',
  },

  'ul ul': {
    marginTop: '8px',
  },

  p: {
    margin: 0,
  },

  strong: {
    fontWeight: 500,
  },
}));
